import { type CreateCarouselBannerInput } from "src/features/HomepageCarouselBanners/models";

import { useMutation } from "@tanstack/react-query";
import { decamelizeKeys } from "humps";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { cmsClient } from "src/services/cmsClient";
import { CustomToast } from "src/components/CustomToast";

const createCarouselBanner = async (data: CreateCarouselBannerInput) => {
	const url = "/homepage/admin/carouselbanner/";
	const { feed, selectedFeed, ...rest } = data as any;
	const payload = decamelizeKeys(rest) as Record<string, unknown>;
	if (feed) payload.feed_id = feed;
	const response = await cmsClient.post(url, payload);

	return response.data;
};

const useCreateCarouselBanner = () => {
	const navigate = useNavigate();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Saved Successfully" />);
		navigate("/vendor-sponsorship/homepage-carousel/banners?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast
				type="Error"
				message="There is an error creating the carousel banner"
			/>
		);
	};

	const mutation = useMutation(createCarouselBanner, { onSuccess, onError });
	return mutation;
};

export default useCreateCarouselBanner;
